module.exports = __webpack_public_path__ + "img/loading.eb360132.gif";